import { writable } from 'svelte/store';

export const filter = writable(true);
